module.exports = __webpack_public_path__ + "media/images/flags/16/Saint-Martin-048bea217015ba9362516cb656fa5460.png";